import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import {
  AppButton,
  Box,
  // costFormater,
  RoundDoneIcon,
  Text,
} from '@common-fe/common-fe';

import { ModalWrapper } from '@/components';

import { useStore } from '../store/useSuccessContributionModal.store';

const headerText = 'Success';

export const SuccessContributionModal = () => {
  const { t } = useTranslation();
  const holdPeriod = useStore((store) => store.holdPeriod);
  const visible = useStore((store) => store.modalVisible);
  const onSetVisible = useStore((store) => store.handleChangeVisibility);
  const onSubmit = useStore((store) => store.onSubmit);
  const description = useMemo(() => `We will debit your designated account and funds will be available within ${holdPeriod} business days.`, [holdPeriod]);
  return (
    <ModalWrapper testId="SuccessContributionModal" visible={visible} onSetVisible={onSetVisible}>
      <Box align="center" pad={{ vertical: 'spacing24', horizontal: 'spacing128' }}>
        <RoundDoneIcon />
        <Text
          data-testid="SuccessContributionModal_modal_header"
          margin={{ vertical: 'spacing12' }}
          textAlign="center"
          size="24px"
          weight={700}
        >
          {headerText}
        </Text>

        <Text
          data-testid="SuccessContributionModal_modal_help-text"
          margin={{ bottom: 'spacing24' }}
          textAlign="center"
        >
          {description}
        </Text>
        <AppButton
          testId="SuccessContributionModal_modal"
          onClick={onSubmit}
          width="200px"
        >
          {t('Got It!')}
        </AppButton>
      </Box>
    </ModalWrapper>
  );
};
